import { createSelector } from '@ngrx/store';

import { wizzardState } from '../root';

export const getWizzardMenuFlowPageByPageId = (pageIdentifier: number) =>
    createSelector(wizzardState, (wizzard) => wizzard.itemsMenuFlow?.Pages?.find((p) => p.PageIdentifier === pageIdentifier) || null);
